import { MicrochartTheme } from "../.internal/themes/MicrochartTheme";
export default MicrochartTheme;